import React from "react";
import { cn } from "@/utils/cn";

type CloseIconProps = {
  className?: string;
};

export const CloseIcon: React.FC<CloseIconProps> = ({ className }) => (
  <svg
    className={cn("h-6 w-6", className)}
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);
